import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { Main } from '../components/Main';
import { IDefaultProps } from '../IDefaultProps';
import { DefaultTheme, GlobalStyle } from '../theme/theme';
import { FooterLayout } from './FooterLayout/FooterLayout';
import { HeaderLayout } from './HeaderLayout/HeaderLayout';
import { Wrapper } from './Wrapper';

const Content = ({ children }: IDefaultProps) => {
  return (
    <ThemeProvider theme={DefaultTheme}>
      <Wrapper>
        <GlobalStyle />
        <HeaderLayout />
        <Main>{children}</Main>
        <FooterLayout />
      </Wrapper>
    </ThemeProvider>
  );
};

export const Base = (props: IDefaultProps) => <Content {...props} />;
